import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from 'app/core/core.module';
import { SiteComponent } from './pages/site/site.component';
import { SiteRoutingModule } from './site-routing.module';
import { SiteGridComponent } from './components/site-grid/site-grid.component';
import { SiteDetailComponent } from './components/site-detail/site-detail.component';
import { AccessTypeListModule } from '@components/access-type-list/access-type-list.module';
import { DockTypeListModule } from '@components/dock-type-list/dock-type-list.module';
import { SiteModeListModule } from '@components/site-mode-list/site-mode-list.module';
import { IndeterminateDirective } from '@directives/indeterminate.directive';
// import { AgmCoreModule } from '@agm/core';
import { IvyCarouselModule } from 'angular-responsive-carousel';
import { SitePictureModule } from './components/site-picture/site-picture.module';
import { NumericDirective } from '@directives/numeric.directive';

@NgModule({
  imports: [
    CommonModule,
    SiteRoutingModule,
    CoreModule,
    AccessTypeListModule,
    DockTypeListModule,
    SiteModeListModule,
    IvyCarouselModule,
    SitePictureModule,
    // AgmCoreModule
  ],
  declarations: [
    SiteComponent,
    SiteGridComponent,
    SiteDetailComponent,
    IndeterminateDirective,
    NumericDirective
  ]
})
export class SiteModule { }
